"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colli-del-tronto": {
    "94b99f37": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "casaregnano": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ed274f6": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "case-sparse": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad79f168": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-la-rocca": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41aede2b": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "vallicella": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7021ca14": [{
      "hkey": "84006e79",
      "slug": "villa-san-giuseppe",
      "name": "Villa San Giuseppe",
      "primary": true,
      "skipSearch": false
    }],
    "villa-san-giusepe": [{
      "hkey": "84006e79",
      "slug": "villa-san-giuseppe",
      "name": "Villa San Giuseppe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "210b061b": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "vivare": [{
      "hkey": "a39ee031",
      "slug": "colli-del-tronto",
      "name": "Colli del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;